var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.question.otherOptionContentField)?_c('div',[_c('label',[_c('input',{attrs:{"type":"radio","disabled":""}}),_vm._v(" "),_c('span',{staticClass:"color_959fa4"},[_vm._v(_vm._s(_vm.question.otherOptionContentField))])])]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }